const serviceUrl = 'https://aloxa.ai/flaskservice/'

// Timeout in ms for all API calls. The predict_all ML inference call can take 20–40s
// on the server under load; 60s gives it room while preventing indefinite spinner.
const API_TIMEOUT_MS = 60000;

export const postApi = async (url, params) => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), API_TIMEOUT_MS);

  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  try {
    const response = await fetch(`${serviceUrl}${url}`, {
      method: 'POST',
      body: JSON.stringify(params),
      headers: myHeaders,
      signal: controller.signal
    });
    clearTimeout(timeoutId);
    const data = await response.json();
    return data;
  } catch (err) {
    clearTimeout(timeoutId);
    if (err.name === 'AbortError') {
      throw new Error('Request timed out. Please check your connection and try again.');
    }
    throw err;
  }
};
